import React, { useContext } from 'react'
import { EventsContext, LanguageContext } from '../context'

function AboutPage() {

  const { promptCreateEvent } = useContext(EventsContext)
  const { t } = useContext(LanguageContext)

  return (
    <div className='my-6 content-parent'>
      <div>
        <h3 className='content-title mb-12 !text-center'>{t('about.title')}</h3>

        <p className='content-text max-w-3xl mx-auto !text-justify'>
          <p className='content-text max-w-3xl mx-auto !text-justify'>
            {t('about.text1')}
          </p><br />
          <p className='content-text max-w-3xl mx-auto !text-justify'>
            {t('about.text2')}
          </p><br />
          <p className='content-text max-w-3xl mx-auto !text-justify'>
            {t('about.text3')}
          </p><br />
          <p className='content-text max-w-3xl mx-auto !text-justify'>
            {t('about.text4')}
          </p>
        </p>

      </div>
      <br /><br /><br />
      <div className='mb-10'>
        <button className='mx-auto big max-w-96 w-full' onClick={promptCreateEvent}>{t('event.create_button')}</button>
      </div>
    </div>
  )
}

export default AboutPage
